const I18n = (window as any).I18n
export default I18n
